import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './style.scss';
import { Article } from '../../shared/interfaces';
import { useParams } from 'react-router';

const ArticleDetailsV3: React.FC = () => {
  const [article, setArticle] = useState<Article | null>(null);
  const [articles, setArticles] = useState<Article[]>([]);
  const { id } = useParams();

  useEffect(() => {
    if (!id) return;

    fetch(`https://strapi-production-a706.up.railway.app/api/articles?filters[id][$eq]=${id}&populate=*`)
      .then((res) => res.json())
      .then((data) => {
        setArticle(data.data[0]);
      })
      .catch((err) => console.error('Failed to fetch article:', err));

    window.scrollTo(0, 0);

    fetch('https://strapi-production-a706.up.railway.app/api/articles?populate=*&sort=createdAt:desc')
      .then((res) => res.json())
      .then((data) => {
        const filteredArticles = data.data.filter((article: Article) => article.id !== Number(id));
        setArticles(filteredArticles);
      })
      .catch((err) => console.error('Failed to fetch articles:', err));
  }, [id]);

  const formatAlbanianDate = (isoDate: string | undefined) => {
    if (!isoDate) return '';

    const months: { [key: string]: string } = {
      January: 'Janar',
      February: 'Shkurt',
      March: 'Mars',
      April: 'Prill',
      May: 'Maj',
      June: 'Qershor',
      July: 'Korrik',
      August: 'Gusht',
      September: 'Shtator',
      October: 'Tetor',
      November: 'Nëntor',
      December: 'Dhjetor',
    };

    const date = new Date(isoDate);
    const enMonth = date.toLocaleString('en-US', { month: 'long' });
    const sqMonth = months[enMonth] || enMonth;

    return `${date.getDate()} ${sqMonth} ${date.getFullYear()}`;
  };

  return (
    <div className="article-details">
      <div className="article-main">
        <div className="article-left">
          <img src={article?.image.url} alt="Artikulli" />
          <p className={'title'}>{article?.title}</p>
          <p className={'date'}>
            Publikuar më: <span>{formatAlbanianDate(article?.createdAt)}</span>
          </p>
        </div>
        <div className="article-right">
          <div className="article-content">
            <p>{article?.description}</p>
          </div>
        </div>
      </div>

      <div className="related">
        <h3 className="title">Artikujt më të fundit</h3>
        <div className="list">
          {articles?.map((item) => (
            <div className="card" key={item.id}>
              <h4>{item.title}</h4>
              <p>
                {item?.description?.length > 100
                  ? item?.description.substring(0, 100) + '...'
                  : item?.description}
              </p>
              <Link to={`/artikull/${item.id}`}>Lexo më shumë</Link>
            </div>
          ))}
        </div>
      </div>

      <div
        className="templates__more-button-wrapper"
        style={{ textAlign: 'center', marginTop: '30px' }}
      >
        <Link to="/artikuj" className="button button--secondary">
          <span>Më shumë artikuj</span>
        </Link>
      </div>
    </div>
  );
};

export default ArticleDetailsV3;
